// extracted by mini-css-extract-plugin
export default {"loader":"_LZNJ0bYS0eYk1fmT2Qs"};